export default "__VITE_ASSET__BDJFdqRb__"